import type { Debug } from "@otto-ec/global-resources/debug";
import type { GlobalStorage } from "@otto-ec/global-resources/storage";
import { STORAGE } from "../constants/storage";
import { SqrlConsentBanner } from "./SqrlConsentBanner";
import { Log } from "../constants/log";
import {Storage} from "@otto-ec/global-resources/storage";
export abstract class SqrlStorage {
  private static log(): Debug<Log.STORAGE> {
    const { logger } = window.o_global.debug;
    return logger(Log.STORAGE);
  }

  static getLocalStorage(): GlobalStorage {
    return new Storage(window.localStorage);
  }

  static setItem(name: STORAGE, value: string) {
    if (SqrlConsentBanner.isEnabled()) {
      this.getLocalStorage().setItem(name, value);
    }
  }
  static removeItem(name: STORAGE) {
    this.getLocalStorage().removeItem(name);
  }

  static getItem(name: STORAGE): string | null {
    return SqrlConsentBanner.isEnabled() ? this.getLocalStorage().getItem(name) : null;
  }
}
